export const GROUP_NOTE_FORMATS = new Set(['note_create', 'note_update', 'note_delete']);

export const isGroupNoteMessage = (message) => GROUP_NOTE_FORMATS.has(String(message?.message_format || '').toLowerCase());

export const getGroupNotePreviewText = (message) => {
  const format = String(message?.message_format || '').toLowerCase();
  if (format === 'note_create') return 'ノートが作成されました。';
  if (format === 'note_update') return 'ノートが修正されました。';
  if (format === 'note_delete') return 'ノートが削除されました。';
  if (format === 'image') return '画像を送信しました';
  if (format === 'file') return message?.file_original_name || 'ファイルを送信しました';
  return String(message?.content || '').replace(/\s+/g, ' ').trim() || '';
};
